// Contact slide: the copy button next to the email address
export default function initContact() {
  for (const button of document.querySelectorAll("[data-copy]")) {
    const icon = button.querySelector("i");
    const note = button.querySelector(".contact__copied");
    let timer = 0;
    button.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(button.dataset.copy);
      } catch {
        // no clipboard access (old browser, http): open the mail app instead
        location.href = `mailto:${button.dataset.copy}`;
        return;
      }
      icon.className = "fa fa-check";
      note.textContent = "Copied";
      clearTimeout(timer);
      timer = setTimeout(() => {
        icon.className = "fa fa-clone";
        note.textContent = "";
      }, 1800);
    });
  }
}
